module.exports = new __parcel__URL__("JiraIcon.a06d5f95.svg").toString();